// import React, { useEffect, useRef, useState } from "react";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { Link } from "react-router-dom";
// import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
// import "./Navigation.css";
// // import logo from "../../assets/images/Logo-white.png";
// import { IoMenuOutline } from "react-icons/io5";

// function Navigation() {

//   const [expanded, setExpanded] = useState(false);
//   const [showPolicies, setShowPolicies] = useState(false);
//   const [showIsoCert, setShowIsoCert] = useState(false);
//   const dropdownRef = useRef(null);
//   // const [showPolicies, setShowPolicies] = useState(false);
//   const [reportsOpen, setReportsOpen] = useState(false)


//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 0 && expanded) {
//         setExpanded(true);
//       }

//       if (expanded) {
//         setExpanded(false);
//       }
//     }

//     if (expanded) {
//       window.addEventListener('scroll', handleScroll);
//     }
//     window.scrollTo(0, 0);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     }

//   }, [expanded]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setReportsOpen(false);
//         setShowPolicies(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);


//   const handleClick = () => {
//     setExpanded(false);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const handleToggle = () => {
//     if (window.scrollY > 0) {

//       setExpanded(true)
//       setTimeout(() => {
//         setExpanded(true);
//       }, 800);
//     }
//     else {
//       setExpanded(!expanded)
//     }
//   }


//   return (
//     <Navbar
//       collapseOnSelect
//       expand="lg"
//       className="text-white bg-white p-1 shadow px-1"
//       id="rescstomcss_1"
//       expanded={expanded}
//       style={{ background: "#0000" }}
//     >
//       <div className="logo-container">
//         <Link to="/">
//           <img
//             className="logo-image p-1"
//             src="/gautamsolarLogo.webp"
//             width={150}
//             height={51}
//             alt="Gautam Solar Logo"
//             style={{ background: "#a20000", borderRadius: "16px" }}
//           />
//         </Link>
//       </div>

//       <button aria-label="menu" onClick={handleToggle} className="d-block d-lg-none border rounded p-1">
//         <IoMenuOutline size={30} />
//       </button>

//       <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
//         <Nav
//           className="me-auto navigation d-flex align-items-center align-items-custom"
//           id="navbartop"
//           style={{ fontSize: "18px", width: "100%" }}
//         >
//           <Link to="/" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             Home
//           </Link>
//           <Link to="/aboutus" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             About Us
//           </Link>

//           <Link to="/inverter" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             Inverter
//           </Link>
//           <Link to="/bess" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             BESS
//           </Link>

//           {/* Solar Modules Dropdown (unchanged) */}
//           <div className="dropdown">
//             <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
//               Solar Modules <span><MdOutlineKeyboardArrowDown /></span>
//             </Link>
//             <div className="dropdown-content p-1 rounded">
//               <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap" }}>
//                 <Link to="/topcon" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
//                   N-Type TOPCon Solar Modules
//                 </Link>
//               </div>
//               <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
//                 <Link to="/mono" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
//                   Mono PERC Solar Modules
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Solar Power Plant Dropdown (unchanged) */}
//           <div className="dropdown">
//             <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
//               Solar Power Plant <span><MdOutlineKeyboardArrowDown /></span>
//             </Link>
//             <div className="dropdown-content p-1 rounded">
//               <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap" }}>
//                 <Link to="/solarplants" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
//                   Solar Power Plant
//                 </Link>
//               </div>
//               <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
//                 <Link to="/kusum" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
//                   PM-Kusum-Yojna
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <Link to="/blog" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             Blog
//           </Link>
//           <Link to="/contactus" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
//             Contact Us
//           </Link>

//           {/* ========== FIXED RESOURCES DROPDOWN with nested REPORTS ========== */}
//           <div className="dropdown" ref={dropdownRef}>
//             <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
//               Resources <span><MdOutlineKeyboardArrowDown /></span>
//             </Link>
//             <div className="dropdown-content p-3 rounded" style={{ minWidth: "190px", position: "absolute", backgroundColor: "white", zIndex: 1000 }}>
//               {/* Grid container – will be block on desktop, grid on mobile */}
//               <div className="resources-grid">
//                 {/* ESG Compliance */}
//                 <div className="dropdown-item">
//                   <Link to="/solar-saving" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
//                     Solar Savings
//                   </Link>
//                 </div>
//                 <div className="dropdown-item">
//                   <Link to="/esg" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
//                     ESG Compliance
//                   </Link>
//                 </div>

//                 {/* Quality Certificate */}
//                 <div className="dropdown-item">
//                   <Link to="/quality" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
//                     Quality Certificate
//                   </Link>
//                 </div>

//                 {/* Media */}
//                 <div className="dropdown-item">
//                   <Link to="/media" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
//                     Media
//                   </Link>
//                 </div>

//                 {/* CSR */}
//                 <div className="dropdown-item">
//                   <Link to="/csr" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
//                     CSR
//                   </Link>
//                 </div>

//                 {/* White Paper */}
//                 <div className="dropdown-item">
//                   <Link to="/whitepaper" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
//                     White Paper
//                   </Link>
//                 </div>

//                 {/* Reports button */}
//                 <div className="report-button-wrapper">
//                   <button
//                     onClick={(e) => {
//                       e.preventDefault();
//                       setReportsOpen(!reportsOpen);
//                       setShowPolicies(false);
//                     }}
//                     style={{
//                       width: "100%",
//                       textAlign: "left",
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       fontSize: "13px",
//                       color: "#a20000",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       padding: "8px 12px",
//                       fontWeight: 600
//                     }}
//                   >
//                     Reports
//                     <span>{reportsOpen ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}</span>
//                   </button>
//                 </div>
//               </div>

//               {/* Expandable Reports content – shown below the grid */}
//               {reportsOpen && (
//                 <div className="reports-expanded-content" style={{ height: '100px', overflow: 'auto', marginTop: "1rem", borderTop: "1px solid #eee", paddingTop: "1rem" }}>
//                   {/* GSPL Policies section */}
//                   <div>
//                     <button
//                       onClick={() => setShowPolicies(!showPolicies)}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         width: "100%",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         padding: "6px 0",
//                         fontSize: "13px",
//                       }}
//                       className="nav-link"
//                     >
//                       <span style={{ color: "#a20000", fontWeight: 500 }}>GSPL Policies</span>
//                       {showPolicies ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
//                     </button>

//                     {showPolicies && (
//                       <div className="policy-subitems" style={{ marginLeft: "1px", marginTop: "4px" }}>
//                         <button className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() => window.open('/documents/Business_Integrity&Confidential_Information_Policy.pdf', '_blank')}>
//                           Business Integrity & Confidential Information Policy
//                         </button>

//                         <button className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() => window.open('/documents/Environmental&Sustainability_Policy.pdf', '_blank')}>
//                           Environmental & Sustainability Policy
//                         </button>

//                         <button className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() => window.open('/documents/Sustainable_Procurement_Policy.pdf', '_blank')}>
//                           Sustainable Procurement Policy
//                         </button>

//                         <button className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() => window.open('/documents/Responsible_Workplace&Human_Rights_Policy.pdf', '_blank')}>
//                           Responsible Workplace & Human Rights Policy
//                         </button>


//                         <button className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() => window.open('/documents/Living_Wage_Policy.pdf', '_blank')}>
//                           Living Wage Policy
//                         </button>

//                         <button
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() =>
//                             window.open(
//                               "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
//                               "_blank"
//                             )
//                           }
//                         >
//                           GHG Emission Report
//                         </button>

//                         <button
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                           onClick={() =>
//                             window.open(
//                               "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
//                               "_blank"
//                             )
//                           }
//                         >
//                           ESG KPI ROADMAP UPTO FY 2030-31
//                         </button>


//                         {/* <a
//                           href="/documents/Business_Integrity&Confidential_Information_Policy.pdf"
//                           download
//                           onClick={handleClick}
//                           rel="noopener noreferrer"
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                         >
//                           Business Integrity & Confidential Information Policy
//                         </a> */}
//                         {/* <a
//                           href="/documents/Environmental&Sustainability_Policy.pdf"
//                           download
//                           rel="noopener noreferrer"
//                           onClick={handleClick}
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                         >
//                           Environmental & Sustainability Policy
//                         </a> */}
//                         {/* <a
//                           href="/documents/Sustainable_Procurement_Policy.pdf"
//                           download
//                           rel="noopener noreferrer"
//                           onClick={handleClick}
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                         >
//                           Sustainable Procurement Policy
//                         </a> */}
//                         {/* <a
//                           href="/documents/Responsible_Workplace&Human_Rights_Policy.pdf"
//                           download
//                           rel="noopener noreferrer"
//                           onClick={handleClick}
//                           className="nav-link border-bottom"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                         >
//                           Responsible Workplace & Human Rights Policy
//                         </a> */}
//                         {/* <a
//                           href="/documents/Living_Wage_Policy.pdf"
//                           download
//                           rel="noopener noreferrer"
//                           onClick={handleClick}
//                           className="nav-link"
//                           style={{ display: "block", padding: "6px 12px", fontSize: "13px" }}
//                         >
//                           Living Wage Policy
//                         </a> */}
//                       </div>
//                     )}
//                   </div>

//                   {/* GHG Report */}
//                   {/* ESG Roadmap */}
//                   {/* <div style={{ marginTop: "12px" }}>
//                     <a
//                       href="/documents/Gautam_Solar_GHG_Emission_Report.pdf"
//                       download
//                       rel="noopener noreferrer"
//                       onClick={handleClick}
//                       className="nav-link"
//                       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
//                     >
//                       GHG Emission Report
//                     </a>
//                   </div>

//                   <div>
//                     <a
//                       href="/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf"
//                       download
//                       rel="noopener noreferrer"
//                       onClick={handleClick}
//                       className="nav-link"
//                       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
//                     >
//                       ESG KPI ROADMAP UPTO FY 2030-31
//                     </a>
//                   </div> */}
//                   {/* 
//                   <div style={{ marginTop: "12px" }}>
//                     <button
//                       className="nav-link border-bottom"
//                       style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                       onClick={() =>
//                         window.open(
//                           "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
//                           "_blank"
//                         )
//                       }
//                     >
//                       GHG Emission Report
//                     </button>
//                   </div> */}

//                   {/* ESG Roadmap */}
//                   {/* <div>
//                     <button
//                       className="nav-link border-bottom"
//                       style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                       onClick={() =>
//                         window.open(
//                           "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
//                           "_blank"
//                         )
//                       }
//                     >
//                       ESG KPI ROADMAP UPTO FY 2030-31
//                     </button>
//                   </div> */}


//                   <div>
//                     <button
//                       onClick={() => setShowIsoCert(!showIsoCert)}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         width: "100%",
//                         background: "none",
//                         border: "none",
//                         cursor: "pointer",
//                         padding: "6px 0",
//                         fontSize: "13px",
//                       }}
//                       className="nav-link"
//                     >
//                       <span style={{ color: "#a20000", fontWeight: 500 }}>ISO Certificates</span>
//                       {showIsoCert ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
//                     </button>

//                     {showIsoCert && (

//                       <div
//                         className="policy-subitems"
//                         style={{ marginLeft: "12px", marginTop: "4px" }}
//                       >
//                         <div>
//                           <button
//                             className="nav-link border-bottom"
//                             style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                             onClick={() => window.open("/documents/GSPL_9001.pdf", "_blank")}
//                           >
//                             ISO-9001
//                           </button>
//                         </div>

//                         <div>
//                           <button
//                             className="nav-link border-bottom"
//                             style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                             onClick={() => window.open("/documents/GSPL_14001.pdf", "_blank")}
//                           >
//                             ISO-14001
//                           </button>
//                         </div>

//                         <div>
//                           <button
//                             className="nav-link border-bottom"
//                             style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
//                             onClick={() => window.open("/documents/GSPL_45001.pdf", "_blank")}
//                           >
//                             ISO-45001
//                           </button>
//                         </div>
//                       </div>
//                       // <div className="policy-subitems" style={{ marginLeft: "12px", marginTop: "4px" }}>
//                       //   <div>
//                       //     <a
//                       //       href="/documents/GSPL_9001.pdf"
//                       //       download
//                       //       rel="noopener noreferrer"
//                       //       onClick={handleClick}
//                       //       className="nav-link"
//                       //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
//                       //     >
//                       //       ISO-9001
//                       //     </a>
//                       //   </div>

//                       //   <div>
//                       //     <a
//                       //       href="/documents/GSPL_14001.pdf"
//                       //       download
//                       //       rel="noopener noreferrer"
//                       //       onClick={handleClick}
//                       //       className="nav-link"
//                       //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
//                       //     >
//                       //       ISO-14001
//                       //     </a>
//                       //   </div>

//                       //   <div>
//                       //     <a
//                       //       href="/documents/GSPL_45001.pdf"
//                       //       download
//                       //       rel="noopener noreferrer"
//                       //       onClick={handleClick}
//                       //       className="nav-link"
//                       //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
//                       //     >
//                       //       ISO-45001
//                       //     </a>
//                       //   </div>

//                       // </div>
//                     )}
//                   </div>
//                   {/* ISO Documents */}
//                 </div>
//               )}
//             </div>
//           </div>
//         </Nav>
//       </Navbar.Collapse>
//     </Navbar>
//   );
// }

// export default Navigation;


// import React, { useEffect, useState } from "react";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { Link } from "react-router-dom";
// import {
//   MdOutlineKeyboardArrowDown,
//   MdOutlineKeyboardArrowUp,
// } from "react-icons/md";
// import { IoMenuOutline } from "react-icons/io5";
// import "./Navigation.css";

// function Navigation() {
//   const [expanded, setExpanded] = useState(false);

//   // Dropdown open states
//   const [productsOpen, setProductsOpen] = useState(false);
//   const [solarModulesOpen, setSolarModulesOpen] = useState(false);
//   const [solutionsOpen, setSolutionsOpen] = useState(false);
//   const [resourcesOpen, setResourcesOpen] = useState(false);
//   const [showPolicies, setShowPolicies] = useState(false);
//   const [showIsoCert, setShowIsoCert] = useState(false);
//   const [companyOpen, setCompanyOpen] = useState(false);

//   // ---------- Close dropdowns on outside click ----------
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (!event.target.closest(".nav-dropdown-wrapper")) {
//         closeAllDropdowns();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // ---------- Close nav on scroll (your existing behaviour) ----------
//   useEffect(() => {
//     const handleScroll = () => {
//       if (expanded && window.scrollY > 0) setExpanded(false);
//     };
//     if (expanded) window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [expanded]);

//   const closeAllDropdowns = () => {
//     setProductsOpen(false);
//     setSolarModulesOpen(false);
//     setSolutionsOpen(false);
//     setResourcesOpen(false);
//     setShowPolicies(false);
//     setShowIsoCert(false);
//     setCompanyOpen(false);
//   };

//   const handleLinkClick = () => {
//     setExpanded(false);
//     closeAllDropdowns();
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleToggle = () => setExpanded((prev) => !prev);

//   // Helper: toggle one dropdown, close the others
//   const toggle = (name) => {
//     const setters = {
//       products: setProductsOpen,
//       solutions: setSolutionsOpen,
//       resources: setResourcesOpen,
//       company: setCompanyOpen,
//     };
//     const current = { products: productsOpen, solutions: solutionsOpen, resources: resourcesOpen, company: companyOpen };

//     Object.keys(setters).forEach((key) => {
//       if (key === name) setters[key](!current[key]);
//       else setters[key](false);
//     });

//     // Reset nested panels when switching
//     if (name !== "products") setSolarModulesOpen(false);
//     if (name !== "resources") {
//       setShowPolicies(false);
//       setShowIsoCert(false);
//     }
//   };

//   return (
//     <Navbar
//       collapseOnSelect
//       expand="lg"
//       className="text-white bg-white p-1 shadow px-1"
//       id="rescstomcss_1"
//       expanded={expanded}
//       style={{ background: "#0000" }}
//     >
//       <div className="logo-container">
//         <Link to="/">
//           <img
//             className="logo-image p-1"
//             src="/gautamsolarLogo.webp"
//             width={150}
//             height={51}
//             alt="Gautam Solar Logo"
//           />
//         </Link>
//       </div>

//       <button
//         aria-label="menu"
//         onClick={handleToggle}
//         className="d-block d-lg-none border rounded p-1"
//       >
//         <IoMenuOutline size={30} />
//       </button>

//       <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
//         <Nav
//           className="me-auto navigation d-flex align-items-center align-items-custom"
//           id="navbartop"
//           style={{ fontSize: "16px", width: "100%" }}
//         >
//           {/* Home */}
//           <Link to="/" onClick={handleLinkClick} className="nav-link">
//             Home
//           </Link>

//           {/* ==================== PRODUCTS ==================== */}
//           <div className="nav-dropdown-wrapper">
//             <span
//               className="nav-trigger nav-link"
//               onClick={() => toggle("products")}
//             >
//               Products
//               <span>
//                 {productsOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             {productsOpen && (
//               <div className="nav-panel">
//                 {/* Solar Modules (nested) */}
//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setSolarModulesOpen(!solarModulesOpen)}
//                   >
//                     Solar Modules
//                     <span>
//                       {solarModulesOpen ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {solarModulesOpen && (
//                     <div className="submenu-items">
//                       <Link
//                         to="/topcon"
//                         onClick={handleLinkClick}
//                         className="nav-link"
//                       >
//                         N-Type TOPCon Solar Modules
//                       </Link>
//                       <Link
//                         to="/mono"
//                         onClick={handleLinkClick}
//                         className="nav-link"
//                       >
//                         Mono PERC Solar Modules
//                       </Link>
//                     </div>
//                   )}
//                 </div>

//                 <Link to="/inverter" onClick={handleLinkClick} className="nav-link">
//                   Inverter
//                 </Link>
//                 <Link to="/bess" onClick={handleLinkClick} className="nav-link">
//                   BESS
//                 </Link>
//               </div>
//             )}
//           </div>

//           {/* ==================== SOLUTIONS ==================== */}
//           <div className="nav-dropdown-wrapper">
//             <span
//               className="nav-trigger nav-link"
//               onClick={() => toggle("solutions")}
//             >
//               Solutions
//               <span>
//                 {solutionsOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             {solutionsOpen && (
//               <div className="nav-panel">
//                 <Link to="/solarplants" onClick={handleLinkClick} className="nav-link">
//                   Solar Power Plant
//                 </Link>
//                 <Link to="/kusum" onClick={handleLinkClick} className="nav-link">
//                   PM-Kusum-Yojna
//                 </Link>
//                 <Link to="/solar-saving" onClick={handleLinkClick} className="nav-link">
//                   Solar Savings
//                 </Link>
//               </div>
//             )}
//           </div>

//           {/* ==================== RESOURCES ==================== */}
//           <div className="nav-dropdown-wrapper">
//             <span
//               className="nav-trigger nav-link"
//               onClick={() => toggle("resources")}
//             >
//               Resources
//               <span>
//                 {resourcesOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             {resourcesOpen && (
//               <div className="nav-panel">
//                 <Link to="/esg" onClick={handleLinkClick} className="nav-link">
//                   ESG Compliance
//                 </Link>
//                 <Link to="/quality" onClick={handleLinkClick} className="nav-link">
//                   Quality Certificate
//                 </Link>
//                 <Link to="/media" onClick={handleLinkClick} className="nav-link">
//                   Media
//                 </Link>
//                 <Link to="/csr" onClick={handleLinkClick} className="nav-link">
//                   CSR
//                 </Link>
//                 <Link to="/whitepaper" onClick={handleLinkClick} className="nav-link">
//                   White Paper
//                 </Link>

//                 {/* GSPL Policies */}
//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setShowPolicies(!showPolicies)}
//                   >
//                     GSPL Policies
//                     <span>
//                       {showPolicies ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {showPolicies && (
//                     <div className="submenu-items">
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/Business_Integrity&Confidential_Information_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Business Integrity & Confidential Information Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/Environmental&Sustainability_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Environmental & Sustainability Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/Sustainable_Procurement_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Sustainable Procurement Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/Responsible_Workplace&Human_Rights_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Responsible Workplace & Human Rights Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open("/documents/Living_Wage_Policy.pdf", "_blank")
//                         }
//                       >
//                         Living Wage Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         GHG Emission Report
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open(
//                             "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         ESG KPI ROADMAP UPTO FY 2030-31
//                       </button>
//                     </div>
//                   )}
//                 </div>

//                 {/* ISO Certificates */}
//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setShowIsoCert(!showIsoCert)}
//                   >
//                     ISO Certificates
//                     <span>
//                       {showIsoCert ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {showIsoCert && (
//                     <div className="submenu-items">
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open("/documents/GSPL_9001.pdf", "_blank")
//                         }
//                       >
//                         ISO-9001
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open("/documents/GSPL_14001.pdf", "_blank")
//                         }
//                       >
//                         ISO-14001
//                       </button>
//                       <button
//                         className="nav-link"
//                         onClick={() =>
//                           window.open("/documents/GSPL_45001.pdf", "_blank")
//                         }
//                       >
//                         ISO-45001
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* ==================== COMPANY ==================== */}
//           <div className="nav-dropdown-wrapper">
//             <span
//               className="nav-trigger nav-link"
//               onClick={() => toggle("company")}
//             >
//               Company
//               <span>
//                 {companyOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             {companyOpen && (
//               <div className="nav-panel">
//                 <Link to="/aboutus" onClick={handleLinkClick} className="nav-link">
//                   About Us
//                 </Link>
//                 <Link to="/csr" onClick={handleLinkClick} className="nav-link">
//                   CSR
//                 </Link>
//                 <Link to="/media" onClick={handleLinkClick} className="nav-link">
//                   Media
//                 </Link>
//               </div>
//             )}
//           </div>

//           {/* Blog */}
//           <Link to="/blog" onClick={handleLinkClick} className="nav-link">
//             Blog
//           </Link>

//           {/* Contact Us */}
//           <Link to="/contactus" onClick={handleLinkClick} className="nav-link">
//             Contact Us
//           </Link>
//         </Nav>
//       </Navbar.Collapse>
//     </Navbar>
//   );
// }

// export default Navigation;

// -----------------------------------------------------------

// import React, { useEffect, useRef, useState } from "react";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { Link } from "react-router-dom";
// import {
//   MdOutlineKeyboardArrowDown,
//   MdOutlineKeyboardArrowUp,
// } from "react-icons/md";
// import {
//   IoMenuOutline,
//   IoHomeOutline,
//   IoCubeOutline,
//   IoBulbOutline,
//   IoFolderOpenOutline,
//   IoBusinessOutline,
//   IoNewspaperOutline,
//   IoCallOutline,
// } from "react-icons/io5";
// import "./Navigation.css";

// function Navigation() {
//   const [expanded, setExpanded] = useState(false);

//   const [productsOpen, setProductsOpen] = useState(false);
//   const [solarModulesOpen, setSolarModulesOpen] = useState(false);
//   const [solutionsOpen, setSolutionsOpen] = useState(false);
//   const [resourcesOpen, setResourcesOpen] = useState(false);
//   const [showPolicies, setShowPolicies] = useState(false);
//   const [showIsoCert, setShowIsoCert] = useState(false);
//   const [companyOpen, setCompanyOpen] = useState(false);

//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth < 993 : false
//   );

//   const closeTimerRef = useRef(null);
//   const isAnimatingScrollRef = useRef(false);

//   useEffect(() => {
//     const onResize = () => setIsMobile(window.innerWidth < 993);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   // Close nav on PAGE scroll only (not while nav's own internal scroll happens).
//   // Uses bubble phase (no capture) — internal scroll of nav won't trigger this.
//   useEffect(() => {
//     const handleScroll = () => {
//       if (isAnimatingScrollRef.current) return;
//       if (expanded) setExpanded(false);
//       if (!isMobile) closeAllDropdowns();
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [expanded, isMobile]);

//   // Outside click closes mobile-opened dropdowns
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (!event.target.closest(".nav-dropdown-wrapper")) {
//         closeAllDropdowns();
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const closeAllDropdowns = () => {
//     setProductsOpen(false);
//     setSolarModulesOpen(false);
//     setSolutionsOpen(false);
//     setResourcesOpen(false);
//     setShowPolicies(false);
//     setShowIsoCert(false);
//     setCompanyOpen(false);
//   };

//   const handleLinkClick = () => {
//     setExpanded(false);
//     closeAllDropdowns();
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   // Mobile: if scrolled down, smoothly scroll to top first, then open.
//   // Uses polling to know when the scroll has actually finished.
//   const handleToggle = () => {
//     if (isMobile && window.scrollY > 0) {
//       isAnimatingScrollRef.current = true;
//       closeAllDropdowns();
//       window.scrollTo({ top: 0, behavior: "smooth" });

//       const startedAt = Date.now();
//       const checkScroll = () => {
//         const atTop = window.scrollY <= 5;
//         const timedOut = Date.now() - startedAt > 1500;
//         if (atTop || timedOut) {
//           setExpanded(true);
//           setTimeout(() => {
//             isAnimatingScrollRef.current = false;
//           }, 300);
//         } else {
//           requestAnimationFrame(checkScroll);
//         }
//       };
//       requestAnimationFrame(checkScroll);
//     } else {
//       setExpanded((prev) => !prev);
//     }
//   };

//   // Mobile click toggle for submenus
//   const toggle = (name) => {
//     if (!isMobile) return;
//     const current = {
//       products: productsOpen,
//       solutions: solutionsOpen,
//       resources: resourcesOpen,
//       company: companyOpen,
//     };
//     const setters = {
//       products: setProductsOpen,
//       solutions: setSolutionsOpen,
//       resources: setResourcesOpen,
//       company: setCompanyOpen,
//     };
//     Object.keys(setters).forEach((key) => {
//       if (key === name) setters[key](!current[key]);
//       else setters[key](false);
//     });
//     if (name !== "products") setSolarModulesOpen(false);
//     if (name !== "resources") {
//       setShowPolicies(false);
//       setShowIsoCert(false);
//     }
//   };

//   // Desktop hover open (JS-driven, reliable switching between dropdowns)
//   const handleWrapperEnter = (name) => {
//     if (isMobile) return;
//     if (closeTimerRef.current) {
//       clearTimeout(closeTimerRef.current);
//       closeTimerRef.current = null;
//     }
//     setProductsOpen(name === "products");
//     setSolutionsOpen(name === "solutions");
//     setResourcesOpen(name === "resources");
//     setCompanyOpen(name === "company");

//     if (name !== "products") setSolarModulesOpen(false);
//     if (name !== "resources") {
//       setShowPolicies(false);
//       setShowIsoCert(false);
//     }
//   };

//   const handleWrapperLeave = () => {
//     if (isMobile) return;
//     if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
//     closeTimerRef.current = setTimeout(() => {
//       closeAllDropdowns();
//     }, 160);
//   };

//   return (
//     <Navbar
//       collapseOnSelect
//       expand="lg"
//       className="text-white bg-white p-1 shadow px-1"
//       id="rescstomcss_1"
//       expanded={expanded}
//       style={{ background: "#0000" }}
//     >
//       <div className="logo-container">
//         <Link to="/">
//           <img
//             className="logo-image p-1"
//             src="/gautamsolarLogo.webp"
//             width={150}
//             height={51}
//             alt="Gautam Solar Logo"
//           />
//         </Link>
//       </div>

//       <button
//         aria-label="menu"
//         onClick={handleToggle}
//         className={`menu-toggle-btn d-block d-lg-none border rounded p-1 ${
//           expanded ? "is-open" : ""
//         }`}
//       >
//         <IoMenuOutline size={30} />
//       </button>

//       <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
//         <Nav
//           className="me-auto navigation d-flex align-items-center align-items-custom"
//           id="navbartop"
//           style={{ fontSize: "16px", width: "100%" }}
//         >
//           {/* Home */}
//           <Link to="/" onClick={handleLinkClick} className="nav-link nav-item-row">
//             <span className="nav-icon">
//               <IoHomeOutline />
//             </span>
//             <span className="nav-label">Home</span>
//           </Link>

//           {/* ==================== PRODUCTS ==================== */}
//           <div
//             className={`nav-dropdown-wrapper ${productsOpen ? "open" : ""}`}
//             onMouseEnter={() => handleWrapperEnter("products")}
//             onMouseLeave={handleWrapperLeave}
//           >
//             <span
//               className="nav-trigger nav-link nav-item-row"
//               onClick={() => toggle("products")}
//             >
//               <span className="nav-icon">
//                 <IoCubeOutline />
//               </span>
//               <span className="nav-label">Products</span>
//               <span className="nav-chevron">
//                 {productsOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             <div className="nav-panel">
//               <div className="nav-panel-inner">
//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setSolarModulesOpen(!solarModulesOpen)}
//                   >
//                     Solar Modules
//                     <span className="nav-chevron">
//                       {solarModulesOpen ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {solarModulesOpen && (
//                     <div className="submenu-items">
//                       <Link
//                         to="/topcon"
//                         onClick={handleLinkClick}
//                         className="nav-link"
//                         style={{ animationDelay: "0.02s" }}
//                       >
//                         N-Type TOPCon Solar Modules
//                       </Link>
//                       <Link
//                         to="/mono"
//                         onClick={handleLinkClick}
//                         className="nav-link"
//                         style={{ animationDelay: "0.08s" }}
//                       >
//                         Mono PERC Solar Modules
//                       </Link>
//                     </div>
//                   )}
//                 </div>

//                 <Link to="/inverter" onClick={handleLinkClick} className="nav-link">
//                   Inverter
//                 </Link>
//                 <Link to="/bess" onClick={handleLinkClick} className="nav-link">
//                   BESS
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* ==================== SOLUTIONS ==================== */}
//           <div
//             className={`nav-dropdown-wrapper ${solutionsOpen ? "open" : ""}`}
//             onMouseEnter={() => handleWrapperEnter("solutions")}
//             onMouseLeave={handleWrapperLeave}
//           >
//             <span
//               className="nav-trigger nav-link nav-item-row"
//               onClick={() => toggle("solutions")}
//             >
//               <span className="nav-icon">
//                 <IoBulbOutline />
//               </span>
//               <span className="nav-label">Solutions</span>
//               <span className="nav-chevron">
//                 {solutionsOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             <div className="nav-panel">
//               <div className="nav-panel-inner">
//                 <Link
//                   to="/solarplants"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.02s" }}
//                 >
//                   Solar Power Plant
//                 </Link>
//                 <Link
//                   to="/kusum"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.08s" }}
//                 >
//                   PM-Kusum-Yojna
//                 </Link>
//                 <Link
//                   to="/solar-saving"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.14s" }}
//                 >
//                   Solar Savings
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* ==================== RESOURCES ==================== */}
//           <div
//             className={`nav-dropdown-wrapper ${resourcesOpen ? "open" : ""}`}
//             onMouseEnter={() => handleWrapperEnter("resources")}
//             onMouseLeave={handleWrapperLeave}
//           >
//             <span
//               className="nav-trigger nav-link nav-item-row"
//               onClick={() => toggle("resources")}
//             >
//               <span className="nav-icon">
//                 <IoFolderOpenOutline />
//               </span>
//               <span className="nav-label">Resources</span>
//               <span className="nav-chevron">
//                 {resourcesOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             <div className="nav-panel">
//               <div className="nav-panel-inner">
//                 <Link
//                   to="/esg"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.02s" }}
//                 >
//                   ESG Compliance
//                 </Link>
//                 <Link
//                   to="/quality"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.08s" }}
//                 >
//                   Quality Certificate
//                 </Link>
//                 {/* <Link
//                   to="/media"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.14s" }}
//                 >
//                   Media
//                 </Link> */}
//                 {/* <Link
//                   to="/csr"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.2s" }}
//                 >
//                   CSR
//                 </Link> */}
//                 <Link
//                   to="/whitepaper"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.26s" }}
//                 >
//                   White Paper
//                 </Link>

//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setShowPolicies(!showPolicies)}
//                   >
//                     GSPL Policies
//                     <span className="nav-chevron">
//                       {showPolicies ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {showPolicies && (
//                     <div className="submenu-items">
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.02s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/Business_Integrity&Confidential_Information_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Business Integrity & Confidential Information Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.06s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/Environmental&Sustainability_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Environmental & Sustainability Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.1s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/Sustainable_Procurement_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Sustainable Procurement Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.14s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/Responsible_Workplace&Human_Rights_Policy.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         Responsible Workplace & Human Rights Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.18s" }}
//                         onClick={() =>
//                           window.open("/documents/Living_Wage_Policy.pdf", "_blank")
//                         }
//                       >
//                         Living Wage Policy
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.22s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         GHG Emission Report
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.26s" }}
//                         onClick={() =>
//                           window.open(
//                             "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
//                             "_blank"
//                           )
//                         }
//                       >
//                         ESG KPI ROADMAP UPTO FY 2030-31
//                       </button>
//                     </div>
//                   )}
//                 </div>

//                 <div className="submenu-group">
//                   <span
//                     className="submenu-heading"
//                     onClick={() => setShowIsoCert(!showIsoCert)}
//                   >
//                     ISO Certificates
//                     <span className="nav-chevron">
//                       {showIsoCert ? (
//                         <MdOutlineKeyboardArrowUp />
//                       ) : (
//                         <MdOutlineKeyboardArrowDown />
//                       )}
//                     </span>
//                   </span>

//                   {showIsoCert && (
//                     <div className="submenu-items">
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.02s" }}
//                         onClick={() =>
//                           window.open("/documents/GSPL_9001.pdf", "_blank")
//                         }
//                       >
//                         ISO-9001
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.08s" }}
//                         onClick={() =>
//                           window.open("/documents/GSPL_14001.pdf", "_blank")
//                         }
//                       >
//                         ISO-14001
//                       </button>
//                       <button
//                         className="nav-link"
//                         style={{ animationDelay: "0.14s" }}
//                         onClick={() =>
//                           window.open("/documents/GSPL_45001.pdf", "_blank")
//                         }
//                       >
//                         ISO-45001
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ==================== COMPANY ==================== */}
//           <div
//             className={`nav-dropdown-wrapper ${companyOpen ? "open" : ""}`}
//             onMouseEnter={() => handleWrapperEnter("company")}
//             onMouseLeave={handleWrapperLeave}
//           >
//             <span
//               className="nav-trigger nav-link nav-item-row"
//               onClick={() => toggle("company")}
//             >
//               <span className="nav-icon">
//                 <IoBusinessOutline />
//               </span>
//               <span className="nav-label">Company</span>
//               <span className="nav-chevron">
//                 {companyOpen ? (
//                   <MdOutlineKeyboardArrowUp />
//                 ) : (
//                   <MdOutlineKeyboardArrowDown />
//                 )}
//               </span>
//             </span>

//             <div className="nav-panel">
//               <div className="nav-panel-inner">
//                 <Link
//                   to="/aboutus"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.02s" }}
//                 >
//                   About Us
//                 </Link>
//                 <Link
//                   to="/csr"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.08s" }}
//                 >
//                   CSR
//                 </Link>
//                 <Link
//                   to="/media"
//                   onClick={handleLinkClick}
//                   className="nav-link"
//                   style={{ animationDelay: "0.14s" }}
//                 >
//                   Media
//                 </Link>
//               </div>
//             </div>
//           </div>

//           {/* Blog */}
//           <Link to="/blog" onClick={handleLinkClick} className="nav-link nav-item-row">
//             <span className="nav-icon">
//               <IoNewspaperOutline />
//             </span>
//             <span className="nav-label">Blog</span>
//           </Link>

//           {/* Contact Us */}
//           <Link
//             to="/contactus"
//             onClick={handleLinkClick}
//             className="nav-link nav-item-row"
//           >
//             <span className="nav-icon">
//               <IoCallOutline />
//             </span>
//             <span className="nav-label">Contact Us</span>
//           </Link>
//         </Nav>
//       </Navbar.Collapse>
//     </Navbar>
//   );
// }

// export default Navigation;


import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import {
  IoMenuOutline,
  IoHomeOutline,
  IoCubeOutline,
  IoBulbOutline,
  IoFolderOpenOutline,
  IoBusinessOutline,
  IoNewspaperOutline,
  IoCallOutline,
} from "react-icons/io5";
import "./Navigation.css";

function Navigation() {
  const [expanded, setExpanded] = useState(false);

  const [productsOpen, setProductsOpen] = useState(false);
  const [solarModulesOpen, setSolarModulesOpen] = useState(false);
  const [inverterOpen, setInverterOpen] = useState(false); // NEW
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showIsoCert, setShowIsoCert] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 993 : false
  );

  const closeTimerRef = useRef(null);
  const isAnimatingScrollRef = useRef(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 993);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close nav on PAGE scroll only (not while nav's own internal scroll happens).
  // Uses bubble phase (no capture) — internal scroll of nav won't trigger this.
  useEffect(() => {
    const handleScroll = () => {
      if (isAnimatingScrollRef.current) return;
      if (expanded) setExpanded(false);
      if (!isMobile) closeAllDropdowns();
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [expanded, isMobile]);

  // Outside click closes mobile-opened dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".nav-dropdown-wrapper")) {
        closeAllDropdowns();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const closeAllDropdowns = () => {
    setProductsOpen(false);
    setSolarModulesOpen(false);
    setInverterOpen(false); // NEW
    setSolutionsOpen(false);
    setResourcesOpen(false);
    setShowPolicies(false);
    setShowIsoCert(false);
    setCompanyOpen(false);
  };

  const handleLinkClick = () => {
    setExpanded(false);
    closeAllDropdowns();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Mobile: if scrolled down, smoothly scroll to top first, then open.
  // Uses polling to know when the scroll has actually finished.
  const handleToggle = () => {
    if (isMobile && window.scrollY > 0) {
      isAnimatingScrollRef.current = true;
      closeAllDropdowns();
      window.scrollTo({ top: 0, behavior: "smooth" });

      const startedAt = Date.now();
      const checkScroll = () => {
        const atTop = window.scrollY <= 5;
        const timedOut = Date.now() - startedAt > 1500;
        if (atTop || timedOut) {
          setExpanded(true);
          setTimeout(() => {
            isAnimatingScrollRef.current = false;
          }, 300);
        } else {
          requestAnimationFrame(checkScroll);
        }
      };
      requestAnimationFrame(checkScroll);
    } else {
      setExpanded((prev) => !prev);
    }
  };

  // Mobile click toggle for submenus
  const toggle = (name) => {
    if (!isMobile) return;
    const current = {
      products: productsOpen,
      solutions: solutionsOpen,
      resources: resourcesOpen,
      company: companyOpen,
    };
    const setters = {
      products: setProductsOpen,
      solutions: setSolutionsOpen,
      resources: setResourcesOpen,
      company: setCompanyOpen,
    };
    Object.keys(setters).forEach((key) => {
      if (key === name) setters[key](!current[key]);
      else setters[key](false);
    });
    if (name !== "products") {
      setSolarModulesOpen(false);
      setInverterOpen(false); // NEW
    }
    if (name !== "resources") {
      setShowPolicies(false);
      setShowIsoCert(false);
    }
  };

  // Desktop hover open (JS-driven, reliable switching between dropdowns)
  const handleWrapperEnter = (name) => {
    if (isMobile) return;
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setProductsOpen(name === "products");
    setSolutionsOpen(name === "solutions");
    setResourcesOpen(name === "resources");
    setCompanyOpen(name === "company");

    if (name !== "products") {
      setSolarModulesOpen(false);
      setInverterOpen(false); // NEW
    }
    if (name !== "resources") {
      setShowPolicies(false);
      setShowIsoCert(false);
    }
  };

  const handleWrapperLeave = () => {
    if (isMobile) return;
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => {
      closeAllDropdowns();
    }, 160);
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="text-white bg-white p-1 shadow px-1"
      id="rescstomcss_1"
      expanded={expanded}
      style={{ background: "#0000" }}
    >
      <div className="logo-container">
        <Link to="/">
          <img
            className="logo-image p-1"
            src="/gautamsolarLogo.webp"
            width={150}
            height={51}
            alt="Gautam Solar Logo"
          />
        </Link>
      </div>

      <button
        aria-label="menu"
        onClick={handleToggle}
        className={`menu-toggle-btn d-block d-lg-none border rounded p-1 ${
          expanded ? "is-open" : ""
        }`}
      >
        <IoMenuOutline size={30} />
      </button>

      <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
        <Nav
          className="me-auto navigation d-flex align-items-center align-items-custom"
          id="navbartop"
          style={{ fontSize: "16px", width: "100%" }}
        >
          {/* Home */}
          <Link to="/" onClick={handleLinkClick} className="nav-link nav-item-row">
            <span className="nav-icon">
              <IoHomeOutline />
            </span>
            <span className="nav-label">Home</span>
          </Link>
          <Link to="/rei" onClick={handleLinkClick} className="nav-link nav-item-row">
            <span className="nav-icon">
              <IoHomeOutline />
            </span>
            <span className="nav-label">REI</span>
          </Link>

          {/* ==================== PRODUCTS ==================== */}
          <div
            className={`nav-dropdown-wrapper ${productsOpen ? "open" : ""}`}
            onMouseEnter={() => handleWrapperEnter("products")}
            onMouseLeave={handleWrapperLeave}
          >
            <span
              className="nav-trigger nav-link nav-item-row"
              onClick={() => toggle("products")}
            >
              <span className="nav-icon">
                <IoCubeOutline />
              </span>
              <span className="nav-label">Products</span>
              <span className="nav-chevron">
                {productsOpen ? (
                  <MdOutlineKeyboardArrowUp />
                ) : (
                  <MdOutlineKeyboardArrowDown />
                )}
              </span>
            </span>

            <div className="nav-panel">
              <div className="nav-panel-inner">
                <div className="submenu-group">
                  <span
                    className="submenu-heading"
                    onClick={() => {
                      setSolarModulesOpen((prev) => !prev);
                      setInverterOpen(false);
                    }}
                  >
                    Solar Modules
                    <span className="nav-chevron">
                      {solarModulesOpen ? (
                        <MdOutlineKeyboardArrowUp />
                      ) : (
                        <MdOutlineKeyboardArrowDown />
                      )}
                    </span>
                  </span>

                  {solarModulesOpen && (
                    <div className="submenu-items">
                      <Link
                        to="/topcon"
                        onClick={handleLinkClick}
                        className="nav-link"
                        style={{ animationDelay: "0.02s" }}
                      >
                        N-Type TOPCon Solar Modules
                      </Link>
                      <Link
                        to="/mono"
                        onClick={handleLinkClick}
                        className="nav-link"
                        style={{ animationDelay: "0.08s" }}
                      >
                        Mono PERC Solar Modules
                      </Link>
                    </div>
                  )}
                </div>

                {/* ---------- INVERTER (now a collapsible submenu) ---------- */}
                <div className="submenu-group">
                  <span
                    className="submenu-heading"
                    onClick={() => {
                      setInverterOpen((prev) => !prev);
                      setSolarModulesOpen(false);
                    }}
                  >
                    Inverter
                    <span className="nav-chevron">
                      {inverterOpen ? (
                        <MdOutlineKeyboardArrowUp />
                      ) : (
                        <MdOutlineKeyboardArrowDown />
                      )}
                    </span>
                  </span>

                  {inverterOpen && (
                    <div className="submenu-items">
                      <Link
                        to="/inverter-ongrid"
                        onClick={handleLinkClick}
                        className="nav-link"
                        style={{ animationDelay: "0.02s" }}
                      >
                        On Grid Inverter
                      </Link>
                      <Link
                        to="/inverter-hybrid"
                        onClick={handleLinkClick}
                        className="nav-link"
                        style={{ animationDelay: "0.08s" }}
                      >
                        Hybrid Inverter
                      </Link>
                    </div>
                  )}
                </div>

                <Link to="/bess" onClick={handleLinkClick} className="nav-link">
                  BESS
                </Link>
              </div>
            </div>
          </div>

          {/* ==================== SOLUTIONS ==================== */}
          <div
            className={`nav-dropdown-wrapper ${solutionsOpen ? "open" : ""}`}
            onMouseEnter={() => handleWrapperEnter("solutions")}
            onMouseLeave={handleWrapperLeave}
          >
            <span
              className="nav-trigger nav-link nav-item-row"
              onClick={() => toggle("solutions")}
            >
              <span className="nav-icon">
                <IoBulbOutline />
              </span>
              <span className="nav-label">Solutions</span>
              <span className="nav-chevron">
                {solutionsOpen ? (
                  <MdOutlineKeyboardArrowUp />
                ) : (
                  <MdOutlineKeyboardArrowDown />
                )}
              </span>
            </span>

            <div className="nav-panel">
              <div className="nav-panel-inner">
                <Link
                  to="/solarplants"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.02s" }}
                >
                  Solar Power Plant
                </Link>
                <Link
                  to="/kusum"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.08s" }}
                >
                  PM-Kusum-Yojna
                </Link>
                <Link
                  to="/solar-saving"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.14s" }}
                >
                  Solar Savings
                </Link>
              </div>
            </div>
          </div>

          {/* ==================== RESOURCES ==================== */}
          <div
            className={`nav-dropdown-wrapper ${resourcesOpen ? "open" : ""}`}
            onMouseEnter={() => handleWrapperEnter("resources")}
            onMouseLeave={handleWrapperLeave}
          >
            <span
              className="nav-trigger nav-link nav-item-row"
              onClick={() => toggle("resources")}
            >
              <span className="nav-icon">
                <IoFolderOpenOutline />
              </span>
              <span className="nav-label">Resources</span>
              <span className="nav-chevron">
                {resourcesOpen ? (
                  <MdOutlineKeyboardArrowUp />
                ) : (
                  <MdOutlineKeyboardArrowDown />
                )}
              </span>
            </span>

            <div className="nav-panel">
              <div className="nav-panel-inner">
                <Link
                  to="/esg"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.02s" }}
                >
                  ESG Compliance
                </Link>
                <Link
                  to="/quality"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.08s" }}
                >
                  Quality Certificate
                </Link>
                {/* <Link
                  to="/media"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.14s" }}
                >
                  Media
                </Link> */}
                {/* <Link
                  to="/csr"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.2s" }}
                >
                  CSR
                </Link> */}
                <Link
                  to="/whitepaper"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.26s" }}
                >
                  White Paper
                </Link>

                <div className="submenu-group">
                  <span
                    className="submenu-heading"
                    onClick={() => setShowPolicies(!showPolicies)}
                  >
                    GSPL Policies
                    <span className="nav-chevron">
                      {showPolicies ? (
                        <MdOutlineKeyboardArrowUp />
                      ) : (
                        <MdOutlineKeyboardArrowDown />
                      )}
                    </span>
                  </span>

                  {showPolicies && (
                    <div className="submenu-items">
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.02s" }}
                        onClick={() =>
                          window.open(
                            "/documents/Business_Integrity&Confidential_Information_Policy.pdf",
                            "_blank"
                          )
                        }
                      >
                        Business Integrity & Confidential Information Policy
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.06s" }}
                        onClick={() =>
                          window.open(
                            "/documents/Environmental&Sustainability_Policy.pdf",
                            "_blank"
                          )
                        }
                      >
                        Environmental & Sustainability Policy
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.1s" }}
                        onClick={() =>
                          window.open(
                            "/documents/Sustainable_Procurement_Policy.pdf",
                            "_blank"
                          )
                        }
                      >
                        Sustainable Procurement Policy
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.14s" }}
                        onClick={() =>
                          window.open(
                            "/documents/Responsible_Workplace&Human_Rights_Policy.pdf",
                            "_blank"
                          )
                        }
                      >
                        Responsible Workplace & Human Rights Policy
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.18s" }}
                        onClick={() =>
                          window.open("/documents/Living_Wage_Policy.pdf", "_blank")
                        }
                      >
                        Living Wage Policy
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.22s" }}
                        onClick={() =>
                          window.open(
                            "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
                            "_blank"
                          )
                        }
                      >
                        GHG Emission Report
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.26s" }}
                        onClick={() =>
                          window.open(
                            "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
                            "_blank"
                          )
                        }
                      >
                        ESG KPI ROADMAP UPTO FY 2030-31
                      </button>
                    </div>
                  )}
                </div>

                <div className="submenu-group">
                  <span
                    className="submenu-heading"
                    onClick={() => setShowIsoCert(!showIsoCert)}
                  >
                    ISO Certificates
                    <span className="nav-chevron">
                      {showIsoCert ? (
                        <MdOutlineKeyboardArrowUp />
                      ) : (
                        <MdOutlineKeyboardArrowDown />
                      )}
                    </span>
                  </span>

                  {showIsoCert && (
                    <div className="submenu-items">
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.02s" }}
                        onClick={() =>
                          window.open("/documents/GSPL_9001.pdf", "_blank")
                        }
                      >
                        ISO-9001
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.08s" }}
                        onClick={() =>
                          window.open("/documents/GSPL_14001.pdf", "_blank")
                        }
                      >
                        ISO-14001
                      </button>
                      <button
                        className="nav-link"
                        style={{ animationDelay: "0.14s" }}
                        onClick={() =>
                          window.open("/documents/GSPL_45001.pdf", "_blank")
                        }
                      >
                        ISO-45001
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ==================== COMPANY ==================== */}
          <div
            className={`nav-dropdown-wrapper ${companyOpen ? "open" : ""}`}
            onMouseEnter={() => handleWrapperEnter("company")}
            onMouseLeave={handleWrapperLeave}
          >
            <span
              className="nav-trigger nav-link nav-item-row"
              onClick={() => toggle("company")}
            >
              <span className="nav-icon">
                <IoBusinessOutline />
              </span>
              <span className="nav-label">Company</span>
              <span className="nav-chevron">
                {companyOpen ? (
                  <MdOutlineKeyboardArrowUp />
                ) : (
                  <MdOutlineKeyboardArrowDown />
                )}
              </span>
            </span>

            <div className="nav-panel">
              <div className="nav-panel-inner">
                <Link
                  to="/aboutus"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.02s" }}
                >
                  About Us
                </Link>
                <Link
                  to="/csr"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.08s" }}
                >
                  CSR
                </Link>
                <Link
                  to="/media"
                  onClick={handleLinkClick}
                  className="nav-link"
                  style={{ animationDelay: "0.14s" }}
                >
                  Media
                </Link>
              </div>
            </div>
          </div>

          {/* Blog */}
          <Link to="/blog" onClick={handleLinkClick} className="nav-link nav-item-row">
            <span className="nav-icon">
              <IoNewspaperOutline />
            </span>
            <span className="nav-label">Blog</span>
          </Link>

          {/* Contact Us */}
          <Link
            to="/contactus"
            onClick={handleLinkClick}
            className="nav-link nav-item-row"
          >
            <span className="nav-icon">
              <IoCallOutline />
            </span>
            <span className="nav-label">Contact Us</span>
          </Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;


